import i18n from 'services/base/i18n';

export default {
  name: () => i18n.pgettext(
    'Pages|Manage Plans|Plan Firewall|Payment Method',
    'Select Payment Method'
  ),

  addName: () => i18n.pgettext('Pages|Manage Plans|Plan Firewall|Payment Method', 'Add Payment Method'),

  stripeName: () => i18n.pgettext('Pages|Manage Plans|Plan Firewall|Payment Method|Stripe', 'Pay via Stripe'),
  stripeInfo: () => i18n.pgettext('Pages|Manage Plans|Plan Firewall|Payment Method|Stripe', 'Cards, Wallets, Banks, etc.'),
};
